angular
  .module('ui-ng-session-timer')
  .constant('sessionTimerDelegateConfiguration', {
    uniqueComponent: 'session-timer',
    vocabulary: {
      setSession: function (scope, element, attrs, event, waitTime) {
        scope.restartSession(waitTime);
      },
      isAtEnd: function (scope) {
        return scope.sessionTime <= 0;
      },
      restartSession: function (scope, element, attrs, event, waitTime) {
        var masterSessionTime = waitTime || scope.waitTime;
        var sessionTime = parseInt(masterSessionTime);
        var unit = typeof masterSessionTime === 'string' ? masterSessionTime.slice(-1) : 's';

        switch (unit) {
          case 'h':
            scope.sessionTime = sessionTime * 60 * 60;
            break;
          case 'm':
            scope.sessionTime = sessionTime * 60;
            break;
          case 's':
          default:
            scope.sessionTime = sessionTime;
        }

        clearInterval(scope.sessionWatcher);
        scope.onTick({
          count: scope.sessionTime
        });
        scope.sessionWatcher = setInterval(function () {
          scope.sessionTime = scope.sessionTime - 1;

          if (scope.isAtEnd()) {
            clearInterval(scope.sessionWatcher);
            scope.$applyAsync();
            scope.onEnd();
          } else if (_.isFunction(scope.onTick)) {
            scope.onTick({
              count: scope.sessionTime
            });
            scope.$applyAsync();
          }
        }, 1000);
      },
      cancelSession: function (scope) {
        clearInterval(scope.sessionWatcher);
      }
    }
  })
  .directive('sessionTimer', function (DelegateResponder, sessionTimerDelegateConfiguration) {
    return {
      restrict: 'E',
      transclude: true,
      template: '<span ng-if="isAtEnd()" ng-transclude></span>',
      scope: {
        waitTime: '@',
        onTick: '&?',
        onEnd: '&'
      },
      link: DelegateResponder(sessionTimerDelegateConfiguration, function (scope, element, attrs) {
        scope.setSession();
        scope.$on('$destroy', function () {
          scope.cancelSession();
        });
      })
    };
  })
  .service('sessionTimerDelegate', function (sessionTimerDelegateConfiguration, DelegateController) {
    DelegateController(this, sessionTimerDelegateConfiguration);
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-session-timer/src/components/session_timer/session_timer.es.js